import { Box } from '@mui/material'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import EmployeeList from 'module/payroll/global-components/EmployeeList'
import React from 'react'
import BankStatutoryDetails from './BankStatutoryDetails'
import BasicDetails from './BasicDetails'
import PaymentDetails from './PaymentDetails'

const EmpSalaryDetails = ({ drawerState, handleDrawer, details, time_id }) => {
  let bulkDetails = { details, time_id }
  return (
    <AdxDrawerComponent
      state={drawerState}
      anchor="right"
      onClose={handleDrawer}
      headerprops={
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <EmployeeList
            avatar={details?.avatar}
            name={details?.name}
            position={details?.position}
          />
        </Box>
      }
      noPaddingContent
    >
      <AdxTabsBadge
        sxPanel={{ px: 2, pt: 2 }}
        sxTabs={{ '& div.MuiButtonBase-root': { width: { lg: '0' } } }}
      >
        <AdxTabsPanel label="Payment details">
          <PaymentDetails props={bulkDetails} />
        </AdxTabsPanel>
        <AdxTabsPanel label="Basic details">
          <BasicDetails employeeId={details?.id} time_id={time_id} />
        </AdxTabsPanel>
        <AdxTabsPanel label={`Bank & statutory details`}>
          <BankStatutoryDetails employeeId={details?.id} time_id={time_id} />
        </AdxTabsPanel>
      </AdxTabsBadge>
    </AdxDrawerComponent>
  )
}

export default EmpSalaryDetails
